import {
  parseCollectionData,
  parseCustomCollectionData,
} from '@src/mappers/collection/collection.mapper'

export type ProgramsRailData = {
  title: string
  subtitle?: string
  items: CocoApi.CollectionItem[]
} | null

export type CollectionType = 'custom' | 'collection'

export type MediaRailData = {
  title: string
  subtitle?: string
  items: CocoApi.CustomCollectionEntity[]
  className?: string
} | null

export function parseCollectionModuleToRailData(
  raw: unknown,
  collectionType: CollectionType = 'custom'
): MediaRailData {
  const collection = raw as CocoApi.CollectionModule | null

  if (!collection) return null

  if (collectionType === 'collection') {
    return parseCollectionData(collection, collection.entities)
  }

  return parseCustomCollectionData(collection, collection.entities ?? {})
}

export function parseCollectionModuleToProgramsRailData(
  raw: unknown,
  collectionType: CollectionType = 'collection'
): ProgramsRailData {
  const collection = raw as CocoApi.CollectionModule | null

  if (!collection) return null

  if (collectionType === 'custom') {
    const parsed = parseCustomCollectionData(collection, collection.entities ?? {})
    if (!parsed?.items?.length) return null

    return parsed
  }
  const parsed = parseCollectionData(collection, collection.entities)
  if (!parsed?.items?.length) return null

  return parsed
}
